import React from 'react';
import { useTranslation } from '../Context/TranslationContext';
import { FaLinkedin, FaYoutube, FaInstagram, FaFacebook, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const { isTamil } = useTranslation();

  const translations = {
    title: {
      en: "The Bharath Scouts And Guides Tamil Nadu",
      ta: "பாரத சாரணர் மற்றும் சாரணியர் தமிழ்நாடு"
    },
    description: {
      en: "Empowering youth through leadership, service, and adventure. Join us in building a better world.",
      ta: "தலைமை, சேவை மற்றும் சாகச அனுபவங்கள் மூலம் இளைஞர்களை மேம்படுத்துதல். சிறந்த உலகை உருவாக்க எங்களுடன் இணையுங்கள்."
    },
    quickLinks: {
      title: { en: "Quick Links", ta: "விரைவு இணைப்புகள்" },
      links: [
        { en: "Home", ta: "முகப்பு", href: "/" },
        { en: "What We Do", ta: "எங்கள் பணிகள்", href: "/what-we-do" },
        { en: "Products", ta: "பொருட்கள்", href: "/product" },
       
        { en: "Login", ta: "உள்நுழைய", href: "/login" },
        { en: "Donate", ta: "நன்கொடை", href: "/donation" }
      ]
    },
    contact: {
      title: { en: "Contact Us", ta: "தொடர்பு கொள்ள" },
      address: {
        en: "The Bharat Scouts and Guides, State Headquarters, Wenlock Park, Triplicane,Chennai-600005",
        ta: "தமிழக சாரணர் மற்றும் வழிகாட்டிகள், மாநில தலைமையகம், வென்லாக் பூங்கா, திரிபுலிகேன், சென்னை - 600005"
      },
      phone: "+917397292204, 044 2844 2027",
      email: "bsgtamilnadu@gmail.com"
    },
    socialMedia: {
      title: { en: "Follow Us", ta: "பின்தொடருங்கள்" }
    },
    copyright: {
      en: "© 2024 BSG Tamil Nadu. All rights reserved.",
      ta: "© 2024 பிஎஸ்ஜி தமிழ்நாடு. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை."
    }
  };

  return (
    <footer className="bg-[#0A1F44] text-white">
      <div className="container mx-auto max-w-7xl px-6">
        {/* Main Footer Content */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Organization Info */}
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              <img 
                src="/Images/BSGlogo.png" 
                alt="BSG Logo" 
                className="w-16 h-16 object-contain"
              />
              <h2 className="text-lg font-bold leading-tight">
                {translations.title[isTamil ? 'ta' : 'en']}
              </h2>
            </div>
            <p className="text-gray-300 text-sm">
              {translations.description[isTamil ? 'ta' : 'en']}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">
              {translations.quickLinks.title[isTamil ? 'ta' : 'en']}
            </h3>
            <ul className="space-y-3">
              {translations.quickLinks.links.map((link, idx) => (
                <li key={idx}>
                  <a 
                    href={link.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2"
                  >
                    {link[isTamil ? 'ta' : 'en']}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">
              {translations.contact.title[isTamil ? 'ta' : 'en']}
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3 text-gray-300">
                <FaMapMarkerAlt className="w-5 h-5 mt-1 flex-shrink-0" />
                <p className="text-sm">
                  {translations.contact.address[isTamil ? 'ta' : 'en']}
                </p>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <FaPhone className="w-4 h-4" />
                <a href={`tel:${translations.contact.phone}`} className="text-sm hover:text-white transition-colors duration-200">
                  {translations.contact.phone}
                </a>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <FaEnvelope className="w-4 h-4" />
                <a href={`mailto:${translations.contact.email}`} className="text-sm hover:text-white transition-colors duration-200">
                  {translations.contact.email}
                </a>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">
              {translations.socialMedia.title[isTamil ? 'ta' : 'en']}
            </h3>
            <div className="flex gap-4">
              <a href="#" className="bg-gray-700 p-2 rounded-full hover:bg-gray-600 transition-colors duration-200">
                <FaFacebook className="w-5 h-5" />
              </a>
              <a href="#" className="bg-gray-700 p-2 rounded-full hover:bg-gray-600 transition-colors duration-200">
                <FaInstagram className="w-5 h-5" />
              </a>
              <a href="#" className="bg-gray-700 p-2 rounded-full hover:bg-gray-600 transition-colors duration-200">
                <FaYoutube className="w-5 h-5" />
              </a>
              <a href="#" className="bg-gray-700 p-2 rounded-full hover:bg-gray-600 transition-colors duration-200">
                <FaLinkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="py-6 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              {translations.copyright[isTamil ? 'ta' : 'en']}
            </p>
            <div className="flex items-center gap-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors duration-200">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors duration-200">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;